import { idr } from "../../../lib/api";
import { formatTanggal } from "../../../lib/tanggal";

// Isi SATU sel tabel dari definisi kolom `halamanPP.js` (tabel unit, SKU, dan
// item batch). Format tampil ada di satu tempat; kolom mana yang tampil di
// halaman mana ditentukan peta definisi, bukan tiap tabel.
//
// `Status` = komponen pill untuk format status (EligibilityPill /
// ItemStatusPill) — dioper pemanggil supaya berkas ini tidak mengimpor balik
// CashbackProgram.jsx (impor melingkar).

const RATA_KANAN = ["uang", "uang_opsional", "nominal"];
const RATA_TENGAH = ["status", "status_item", "kosong"];

export function rataKolom(kolom) {
  if (RATA_KANAN.includes(kolom.format)) return "right";
  if (RATA_TENGAH.includes(kolom.format)) return "center";
  return "left";
}

export function kelasRata(kolom) {
  const r = rataKolom(kolom);
  return r === "right" ? "text-right" : r === "center" ? "text-center" : "text-left";
}

function angkaAda(v) {
  return v !== null && v !== undefined && v !== "" && !Number.isNaN(Number(v));
}

export default function SelKolom({ kolom, baris, Status }) {
  const v = kolom.isi(baris);
  switch (kolom.format) {
    case "imei":
      return <span className="font-mono text-xs">{v || "-"}</span>;
    case "mono":
      return <span className="font-mono text-[11px] text-slate-700">{v || "-"}</span>;
    case "produk":
      return (
        <>
          <p className="text-slate-900">{(v && v.nama) || "-"}</p>
          <p className="text-[10px] text-slate-500 font-mono">{v && v.sku}</p>
        </>
      );
    case "do_masuk":
      return (
        <>
          <p className="text-xs">{formatTanggal(v && v.tanggal)}</p>
          {v && v.nomor && <p className="text-[10px] text-slate-500 font-mono">{v.nomor}</p>}
        </>
      );
    case "tanggal":
      return <span className="text-xs">{v ? formatTanggal(v) : "-"}</span>;
    case "uang":
    case "uang_opsional":
      return <span className="font-mono">{angkaAda(v) ? idr(v) : "-"}</span>;
    case "nominal":
      return <span className="font-mono font-semibold text-emerald-700">{angkaAda(v) ? idr(v) : "-"}</span>;
    case "status":
    case "status_item":
      return Status ? <Status status={v} /> : <span className="text-xs">{v}</span>;
    case "alasan":
      return <span className="text-[11px] text-slate-600">{v}</span>;
    case "catatan_item":
      // Brief butir 9 & 15 (Agustus): item DITOLAK tetap terlihat lengkap dengan
      // alasan eligibility saat diklaim, supaya bisa diaudit.
      return (
        <div className="text-[11px] text-slate-600">
          {v.status === "rejected" && v.rejection_reason && (
            <p className="text-rose-700"><span className="font-semibold">Alasan tolak:</span> {v.rejection_reason}</p>
          )}
          {v.reclaimed_in_item_id && <p className="text-sky-700">Sudah di-reclaim ke batch baru</p>}
          {v.reclaim_of_item_id && <p className="text-slate-500">Hasil reclaim dari klaim sebelumnya</p>}
          <p className="text-slate-400 mt-0.5" title="Eligibility saat IMEI ini dimasukkan ke batch">{v.eligibility_alasan_saat_klaim}</p>
        </div>
      );
    case "kosong":
      return <span className="text-slate-400 text-xs">-</span>;
    default:
      return <span className="text-xs">{v === null || v === undefined || v === "" ? "-" : v}</span>;
  }
}
